module.exports = __webpack_public_path__ + "img/bb.91c488b7.jpg";